export const news = [
  {
    id: "n01",
    title: "奥田咲新作《融雪的清晨》正式杀青，预计今冬上映",
    date: "2026-09-28",
    category: "新作发布",
    summary:
      "历经三个月的雪国取景拍摄，奥田咲主演的最新电影《融雪的清晨》正式杀青。片方同步公开了首张剧照与上映档期。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20behind%20the%20scenes%20photo%20of%20a%20film%20crew%20in%20a%20snowy%20mountain%20village%20at%20dawn%2C%20cool%20blue%20gray%20tones%20with%20warm%20orange%20sunrise%2C%20misty%20quiet%20atmosphere%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=okuda-news-01&orientation=landscape",
    content: [
      "据发行方消息，由奥田咲领衔主演的电影《融雪的清晨》已于本月完成全部拍摄工作，正式进入后期制作阶段。影片在北部山区的雪国小镇拍摄了近三个月，大量镜头在清晨的自然光下完成。",
      "导演田中启介在杀青现场表示，这次拍摄「几乎是在和天气赛跑」，很多重要的情绪镜头都只有一次机会。他也特别提到奥田咲在零下气温中的稳定发挥，「她把角色的克制演得非常准确」。",
      "片方同步公开了首张剧照，画面中奥田咲饰演的远野千鹤站在融雪的村道上，晨雾尚未散去。影片预计将于今年冬季正式上映，具体档期将在下月公布。",
      "奥田咲本人也在社交平台留言感谢剧组：「这个冬天很长，但每个人都很有耐心。希望大家能在影院里感受到雪化开的那一刻。」",
    ],
  },
  {
    id: "n02",
    title: "《光与影之间》口碑持续走高，结局篇引发广泛讨论",
    date: "2026-08-15",
    category: "作品反响",
    summary:
      "剧集《光与影之间》播出至结局篇，凭借强烈的光影风格与层层反转的叙事，在社交平台引发大量观众讨论。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dramatic%20room%20interior%20with%20harsh%20light%20and%20deep%20shadow%2C%20high%20contrast%20blue%20gray%20and%20warm%20orange%20tones%2C%20chiaroscuro%20lighting%2C%20empty%20moody%20space%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=okuda-news-02&orientation=landscape",
    content: [
      "由奥田咲主演的剧集《光与影之间》上周播出最终回，剧集以一场几乎无声的对视为结局，留下大量解读空间。播出当晚，相关话题迅速登上多个平台的热门榜单。",
      "观众讨论的焦点集中在桐生明里这个角色的选择上。有评论认为，剧本刻意回避了给出标准答案，而把判断权交回给观众，这正是该剧最特别的地方。",
      "奥田咲在接受采访时谈到对结局的理解：「她其实一直没有真正做出选择，这才是最真实的。」她也透露，结尾那个长镜头一共拍了十七条，最终选用的是第四条。",
      "制作方表示，目前没有续订第二季的计划，但不排除以后以特别篇的形式回归。",
    ],
  },
  {
    id: "n03",
    title: "奥田咲出席夏季电影节，红毯造型成焦点",
    date: "2026-07-06",
    category: "活动出席",
    summary:
      "在第 18 届夏季电影节开幕红毯上，奥田咲以一身深蓝灰长裙亮相，作为影片《追忆叙事曲》主创代表出席。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20red%20carpet%20event%20scene%20at%20a%20summer%20film%20festival%20at%20night%2C%20deep%20blue%20gray%20tones%20with%20warm%20orange%20spotlights%2C%20elegant%20atmosphere%2C%20bokeh%20lights%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=okuda-news-03&orientation=landscape",
    content: [
      "第 18 届夏季电影节日前开幕，奥田咲作为影片《追忆叙事曲》的主创代表出席开幕红毯。她以一身深蓝灰长裙配简洁配饰亮相，被现场媒体称为当晚最克制也最耐看的一组造型。",
      "在映后交流环节，奥田咲分享了自己为角色学习钢琴调音的经历：「我在一个老师傅那里待了两个月，学会了听出每一个音最细微的偏差。」",
      "本届电影节将持续十天，《追忆叙事曲》入选主竞赛单元，最终获奖名单将在闭幕式上公布。",
    ],
  },
  {
    id: "n04",
    title: "官方公告：作品资料库完成年度更新，新增短片单元",
    date: "2026-06-20",
    category: "官方公告",
    summary:
      "本站作品资料库已完成年度更新，新增短片单元收录，并补全了各作品的导演、角色与时长信息，方便影迷查阅。",
    cover: "https://readdy.ai/api/search-image?query=minimal%20modern%20archive%20room%20with%20neatly%20stacked%20film%20reels%20on%20shelves%2C%20cool%20blue%20gray%20tones%20with%20warm%20orange%20accent%20light%2C%20clean%20orderly%20composition%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=okuda-news-04&orientation=landscape",
    content: [
      "为了让影迷更完整地了解奥田咲的作品轨迹，本站作品资料库于本月完成了年度更新。本次更新主要包含三个方面。",
      "第一，新增「短片」单元，完整收录了《夏日残响》《白色街灯》《海边的信》等早期短片作品。第二，补全了每部作品的导演、饰演角色、片长与上映年份信息。第三，优化了列表页的筛选与排序功能，现在可以按类型、年份区间快速定位作品。",
      "我们后续还会继续补充幕后花絮与访谈内容。如果发现资料有误，欢迎通过关于页的联系表单告诉我们。",
    ],
  },
  {
    id: "n05",
    title: "奥田咲谈表演：把「不解释」当成一种练习",
    date: "2026-05-11",
    category: "媒体访谈",
    summary:
      "在一档深度访谈节目中，奥田咲回顾了自己十余年的演艺道路，并分享了关于克制表演的理解。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20interview%20studio%20scene%20with%20a%20microphone%20on%20a%20table%20and%20soft%20warm%20lighting%2C%20deep%20blue%20gray%20background%20with%20orange%20accent%20light%2C%20intimate%20calm%20atmosphere%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=okuda-news-05&orientation=landscape",
    content: [
      "在最新一期的深度访谈节目中，奥田咲用很长一段时间聊了「克制」这件事。她说，早年的自己总想把角色的情绪演满，后来才慢慢学会留白。",
      "「观众其实很聪明，你不需要把所有东西都解释清楚。」她提到，《静海之忆》里有一场戏，她什么台词都没有，只是坐在门口，那场戏最终被保留了下来。",
      "谈到未来，她表示希望能尝试更多幕后工作，尤其是剧本开发。「我想知道故事是从哪里长出来的。」",
    ],
  },
  {
    id: "n06",
    title: "《追忆叙事曲》入围年度最佳女主角提名",
    date: "2026-04-02",
    category: "奖项提名",
    summary:
      "凭借在《追忆叙事曲》中对水野沙罗一角的诠释，奥田咲入围本年度最佳女主角提名，颁奖礼将于下月举行。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20award%20ceremony%20stage%20with%20warm%20golden%20spotlight%20and%20deep%20blue%20gray%20curtain%2C%20elegant%20formal%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=okuda-news-06&orientation=landscape",
    content: [
      "年度电影奖项公布提名名单，奥田咲凭借《追忆叙事曲》中的水野沙罗一角入围最佳女主角。这是她继《静海之忆》之后第二次获得该奖项提名。",
      "评审团在评语中写道：「她让沉默成为一种可以听见的语言。」影片本身同时入围最佳影片、最佳原创配乐两个奖项。",
      "颁奖礼将于下月举行。奥田咲方面回应称，「能被记住就已经很好了」，是否出席将视拍摄档期安排而定。",
    ],
  },
  {
    id: "n07",
    title: "拍摄花絮：《等待春天的车站》樱花开场戏是如何完成的",
    date: "2026-03-18",
    category: "拍摄花絮",
    summary:
      "剧组公开了《等待春天的车站》开场戏的幕后花絮，导演组为了等待一场真实的樱吹雪，整整调整了三天的拍摄计划。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20behind%20the%20scenes%20photo%20of%20a%20rural%20train%20platform%20with%20cherry%20blossoms%20in%20full%20bloom%2C%20soft%20pink%20and%20deep%20blue%20gray%20palette%20with%20warm%20orange%20morning%20light%2C%20nostalgic%20calm%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=okuda-news-07&orientation=landscape",
    content: [
      "《等待春天的车站》开场那段没有台词的樱花戏，是很多观众心中的名场面。剧组近日公开了这段戏的完整花絮。",
      "据制片人回忆，为了等到一场真实的樱吹雪，导演组连续三天调整拍摄顺序，「天气预报说会起风，结果第一天一点风都没有。」",
      "奥田咲在花絮中笑着说：「第三天风来的时候，所有人都不敢出声，就怕把它吓跑。」这段镜头最终一次通过。",
    ],
  },
  {
    id: "n08",
    title: "奥田咲确认出演新剧《远方的回声》，挑战双主角设定",
    date: "2026-02-24",
    category: "新作发布",
    summary:
      "官方公布奥田咲将出演全新剧集《远方的回声》，她将在剧中挑战一人分饰两位性格迥异的角色。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20moody%20conceptual%20scene%20of%20two%20mirrored%20silhouettes%20facing%20each%20other%20in%20a%20dim%20room%2C%20deep%20blue%20gray%20tones%20with%20warm%20orange%20rim%20light%2C%20symmetrical%20mysterious%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=okuda-news-08&orientation=landscape",
    content: [
      "官方日前公布，奥田咲将出演全新剧集《远方的回声》，这一次她将挑战一人分饰两个性格完全相反的角色。",
      "据介绍，剧本以「如果当初做了另一个选择」为起点，两条人生线在剧中平行展开，最终在一个意外的瞬间交汇。",
      "该剧预计于明年春季开机，制作方表示希望用更电影化的方式呈现这段双线叙事。",
    ],
  },
  {
    id: "n09",
    title: "回顾：从短片到大银幕，奥田咲的十年作品轨迹",
    date: "2026-01-15",
    category: "专题回顾",
    summary:
      "从 2018 年的短片《夏日残响》到 2024 年的《融雪的清晨》，我们梳理了奥田咲十年间的作品脉络与表演变化。",
    cover: "https://readdy.ai/api/search-image?query=timeline%20concept%20of%20overlapping%20film%20frames%20floating%20in%20dark%20space%2C%20deep%20blue%20gray%20tones%20with%20warm%20orange%20edge%20light%2C%20cinematic%20elegant%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=okuda-news-09&orientation=landscape",
    content: [
      "如果把奥田咲的作品按时间排成一条线，会看到一个非常清晰的成长轨迹。",
      "2018 到 2020 年是她的短片与大银幕起步期，《夏日残响》《遥远的约定》《夜色的彼端》接连上映，题材集中在青春与都市情感。2021 年起，她开始尝试更内在的角色，《静海之忆》被视为转折点。",
      "2023 年之后，她在《追忆叙事曲》《融雪的清晨》中呈现出更沉静的表演风格，也逐渐参与到剧本的讨论中。十年之间，她的表演从「表达情绪」走向了「承载情绪」。",
    ],
  },
  {
    id: "n10",
    title: "奥田咲参与公益短片企划，关注乡村儿童阅读",
    date: "2025-12-05",
    category: "公益活动",
    summary:
      "奥田咲以志愿者身份参与了一部公益短片的拍摄，影片关注乡村儿童的阅读现状，预计于明年上线。",
    cover: "https://readdy.ai/api/search-image?query=warm%20hopeful%20scene%20of%20a%20bright%20reading%20room%20with%20sunlight%20through%20windows%20and%20books%20on%20wooden%20shelves%2C%20soft%20blue%20gray%20tones%20with%20warm%20orange%20light%2C%20gentle%20calm%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=okuda-news-10&orientation=landscape",
    content: [
      "奥田咲日前以志愿者身份参与了一部公益短片的拍摄，影片聚焦乡村儿童的阅读资源问题。",
      "她表示，这次没有剧本，几乎所有镜头都是真实的记录。「我们只是坐在那里，听孩子们读书。」",
      "该短片计划于明年上线，同时将联合多家机构发起图书捐赠活动。",
    ],
  },
];